import { useUser } from '@clerk/nextjs'

import { SNOWBALL_DOMAIN } from '../constants'

export default function useIsEmployee({ domain = SNOWBALL_DOMAIN } = {}) {
  const { user } = useUser()

  return user?.primaryEmailAddress?.emailAddress.endsWith(`@${domain}`) ?? false
}
